import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '../views/Home.vue'
import StudyFresKa from '../views/studies/StudyFresKa.vue'
import StudyCashAway from '../views/studies/StudyCashAway.vue'
import StudyJLGS from '../views/studies/StudyJLGS.vue'
import StudyVisualIdentity from '../views/studies/StudyVisualIdentity.vue'
import StudyTravelGuide from '../views/studies/StudyTravelGuide.vue'
import StudyBanners from '../views/studies/StudyBanners.vue'
import StudyAdvertising from '../views/studies/StudyAdvertising.vue'
import StudyPublication from '../views/studies/StudyPublication.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/fres-ka',
    name: 'StudyFresKa',
    component: StudyFresKa
  },
  {
    path: '/CashAway',
    name: 'StudyCashAway',
    component: StudyCashAway
  },
  {
    path: '/JLGS',
    name: 'StudyJLGS',
    component: StudyJLGS
  },
  {
    path: '/Visual-Identity',
    name: 'StudyVisualIdentity',
    component: StudyVisualIdentity
  },
  {
    path: '/Travel-Guide',
    name: 'StudyTravelGuide',
    component: StudyTravelGuide
  },
  {
    path: '/Banners',
    name: 'StudyBanners',
    component: StudyBanners
  },
  {
    path: '/Advertising',
    name: 'StudyAdvertising',
    component: StudyAdvertising
  },
  {
    path: '/Publication',
    name: 'StudyPublication',
    component: StudyPublication
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes,
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      const el = to.hash.split("#")[1];
      if (el.length) {
        setTimeout(_ => document.getElementById(el).scrollIntoView({ behavior: "smooth" }), 1);
      }
      return;
    }
    return { x: 0, y: 0 }
  }
})

export default router